import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      setIsVisible(scrollPosition > windowHeight * 0.5);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-454">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 bg-[#2F4538] text-[#F5F0E8] shadow-[0_-10px_40px_rgba(47,69,56,0.5)] z-50 lg:hidden border-t border-[#B4A7D6]/30" data-id="element-455">
          <div className="px-4 py-4" data-id="element-456">
            <div className="flex items-center justify-between gap-4" data-id="element-457">
              <div className="flex-1" data-id="element-458">
                <p className="text-[10px] text-[#D4AF37] mb-0.5 uppercase tracking-wider font-bold flex items-center gap-1" data-id="element-459">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" data-id="element-460"></span>
                  Lanzamiento
                </p>
                <p className="font-bold text-lg flex items-center gap-2" data-id="element-461">
                  <span className="text-[#F5F0E8]" data-id="element-462">$15.990</span>
                  <span className="text-xs text-[#F5F0E8]/50 line-through font-normal" data-id="element-463">
                    $96.000
                  </span>
                </p>
              </div>
              <a href="#oferta" className="bg-[#B4A7D6] text-[#F5F0E8] px-6 py-3 rounded-full font-bold text-sm hover:bg-[#9D8FC4] transition-all whitespace-nowrap shadow-lg" data-id="element-464">
                QUIERO MI ACCESO
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}